import { Component, computed, effect, inject, input, InputSignal, output, OutputEmitterRef, Signal, viewChild, ChangeDetectionStrategy } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatPaginator, MatPaginatorIntl, MatPaginatorModule, PageEvent } from '@angular/material/paginator';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatConstantsModule } from '@libs/shared/ui';
import { PaginatorIntlService } from './paginator-intl.service';

// The Glue API related page size and page size options are default options
const pageSizeDefault: number = 36;
const pageSizeOptionsDefault: number[] = [12, 24, 36];

@Component({
  selector: 'ui-paginator',
  templateUrl: './paginator.component.html',
  styleUrls: ['./paginator.component.scss'],
  imports: [
    MatConstantsModule,
    MatPaginatorModule,
    MatInputModule,
    FormsModule,
    MatSlideToggleModule,
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  providers: [{ provide: MatPaginatorIntl, useClass: PaginatorIntlService }],
})
export class PaginatorComponent {
  public matPaginator: Signal<MatPaginator> = viewChild.required(MatPaginator);

  public length: InputSignal<number> = input.required();
  public pageIndex: InputSignal<number> = input(0);
  public pageSize: InputSignal<number | undefined> = input();
  public pageSizeOptions: InputSignal<number[] | undefined> = input();
  public hidePageSize: InputSignal<boolean> = input(false);
  public showFirstLastButtons: InputSignal<boolean> = input(false);
  public disabled: InputSignal<boolean> = input(false);
  public title: InputSignal<string> = input('');

  public intlService: PaginatorIntlService = inject(MatPaginatorIntl);

  public page: OutputEmitterRef<PageEvent> = output();

  public pageSizeComputed: Signal<number> = computed(() => {
    return this.pageSize() ?? pageSizeDefault;
  });

  public pageSizeOptionsComputed: Signal<number[]> = computed(() => {
    return this.pageSizeOptions() ?? pageSizeOptionsDefault;
  });

  public constructor() {
    effect(() => {
      const title: string = this.title();

      if (title) {
        this.intlService.itemsPerPageLabel = `${title} pro Seite:`;
      }
    });
  }
}
